export { default } from './NoResultsPlaceholder';
